import type { Bordereau, Exercice } from '@mairistem/comptabilite';
import type { BaseLiquidationOptions } from '../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../interfaces/pieces/TreeviewActionResult';

class BaseLiquidationAction<T, U extends string> {
	label!: string;

	type!: U;

	isSuperUser: boolean = false;

	isActionPrincipale: boolean = false;

	/**
	 * Prédicat optionnel pour contrôler l’affichage de l’action dans l’UI.
	 * S’il est absent, l’action est affichée.
	 */
	isShown: (bordereau: BordereauWithState, data?: T) => boolean = () => true;

	constructor(options: BaseLiquidationOptions | null = null) {
		this.isSuperUser = options?.isSuperUser ?? false;
		this.isActionPrincipale = options?.isActionPrincipale ?? false;
	}

	execute!: (
		data: T,
		exercice: Exercice,
		bordereau: Bordereau | BordereauWithState,
	) => TreeviewActionResult<T> | TreeviewActionResult<T>[];

	executeAction?: (
		data: T,
		exercice: Exercice,
	) => TreeviewActionResult<T> | TreeviewActionResult<T>[];
}

export default BaseLiquidationAction;
